export default "__VITE_ASSET__CAOyNM$i__"